import { BORDER_COLORS } from "../../../../../components/Charts/constants";
import { toTone } from "../../../../../utils";
import { Savings } from "../../../types";
import { headlineInterestOf } from "../../../utils";
import { AllocationDatum, EarnedDatum } from "./types";

// Allocation: each saving's share of the total current balance, ordered largest
// to smallest. Bar width maps directly to the share percent.
export const buildAllocation = (savings: Savings[]): AllocationDatum[] => {
  const total = savings.reduce((sum, saving) => sum + saving.currentValue, 0);

  if (total <= 0) {
    return [];
  }

  // Colour is keyed to the saving's position in the original list so it matches
  // the dot colour in SavingsHoldings; only the display order is sorted.
  return savings
    .map((saving, index) => ({
      saving,
      color: BORDER_COLORS[index % BORDER_COLORS.length],
    }))
    .toSorted((a, b) => b.saving.currentValue - a.saving.currentValue)
    .map(({ saving, color }) => ({
      id: saving.id,
      name: saving.name,
      percent: (saving.currentValue / total) * 100,
      color,
    }));
};

// Bar width is relative to the largest absolute amount so the longest bar fills the track.
export const buildEarned = (savings: Savings[]): EarnedDatum[] => {
  const maxAbs = savings.reduce(
    (max, saving) => Math.max(max, Math.abs(headlineInterestOf(saving))),
    0,
  );

  return savings
    .toSorted((a, b) => headlineInterestOf(b) - headlineInterestOf(a))
    .map((saving) => {
      const value = headlineInterestOf(saving);
      return {
        id: saving.id,
        name: saving.name,
        value,
        taxWithheld: saving.taxWithheld,
        netReceived: saving.earnedValue,
        tone: toTone(value),
        barWidth: maxAbs > 0 ? (Math.abs(value) / maxAbs) * 100 : 0,
      };
    });
};
